;(function($, undefined){

    var rnn, log, isThirdParty;

  function showSubscriptionsFormModal() {

    // @TODO use fetch and removed jQuery
    $.get('/mailchimp/subscriptions-form/', function(formHTML){
      // @TODO Should be formated with template string, but need to wait for webpack/babel
      var $html = $('<div class="modal fade mailchimp-subscriptions-form-modal in" style="display: block; padding-right: 0px;" aria-hidden="false"><div class="modal-header"><button class="close" data-dismiss="modal">×</button><div class="clearfix"><div class="sectionBanner auto pull-left"><h2>Sign Up!</h2></div><h2 class="text-success upper margin-left pull-left">Daily Newsletters</h2></div></div><div class="modal-body">' + formHTML + '</div></div><div class="modal-backdrop fade in"></div>')

      $html.find('.close')
        .on('click', function(){
          $('.modal.mailchimp-subscriptions-form-modal')
            .removeClass('in').addClass('out')
            .next().css('opacity', 0).delay(0.5).hide()
        })
      $html.appendTo('body')
    })
  }

  function initSubscriptionsFormModal() {
    var cookieName = 'mailchimp.subscriptionsFormModalSeen';
    var cookieOptions = { expires: 365, path: '/' };

    if (!Cookies.get(cookieName)) {
      Cookies.set(cookieName, 'yes', cookieOptions);
      showSubscriptionsFormModal();
    }
  }

  function initMailchimp() {

    // Restict modal to AU sites with the modal enabled, which aren't header/footer includes
    if (rnn.site.network.isAU && rnn.site.showSubscriptionModal && !isThirdParty) {
      initSubscriptionsFormModal();
    }
  }

  rnn = window.rnn;
  log = rnn.logging.log;
  isThirdParty = !!window.header_only || !!window.footer_only;

  rnn.modules.register('mailchimp', {
    init: initMailchimp
  });

})(jQuery);
